import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

import CatalogList from '../../components/CatalogList';
import PrivateData from '../../API/PrivateData';
import Public from '../../API/Public';
import Loading from '../../UI/Loading';
import './index.scss';

import bemClassName from '../../utils/bem';

const currentBookings = bemClassName('current-bookings');

const CurrentBookings = () => {
  const [data, setData] = useState<any>();
  const [currentData, setCurrentData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [errorText, setErrorText] = useState<string>();

  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);

  useEffect(() => {
    if (isLogin !== null && isLogin && !currentData) {
      setIsLoading(true);
      let userBookings: any;
      PrivateData.getPrivateUserDealsCurrentBooking()
        .then((item) => {
          userBookings = item.data;
          if (!userBookings) {
            throw new Error('Текущих бронирований нет');
          }
          if (userBookings.length === 0) {
            throw new Error('Пока бронирований нет');
          }
          const productPromises = item.data.map((bookingItem: any) => {
            return Public.getProduct(
              bookingItem.product.id,
              bookingItem.begindate,
              bookingItem.closedate,
            );
          });
          return Promise.all(productPromises);
        })
        .then((resultsArray) => {
          setCurrentData(userBookings);
          setData(resultsArray);
        })
        .catch((error) => {
          setErrorText(error.message);
          setData(null);
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [isLogin]);

  useEffect(() => {
    document.title = 'Текущие бронирования';
  }, []);

  if (errorText) {
    return <h2 className={currentBookings()}>{errorText}</h2>;
  }

  // eslint-disable-next-line
  return !isLoading ? (
    data ? (
      <CatalogList current data={data} currentData={currentData} />
    ) : (
      <h2 className={currentBookings()}>Текущих бронирований нет</h2>
    )
  ) : (
    <Loading externalClassName={currentBookings('loading')} />
  );
};

export default CurrentBookings;
